<template>
  <div class="planning">
    <planning-list v-if="getApplicationSetting('ipad_planning_view') === 'list'" />
    <planning-default v-else />
  </div>
</template>

<script>
import PlanningList from '@/views/planning/List'
import PlanningDefault from '@/views/planning/Default'
export default {
  name: 'planning',
  components: {
    PlanningList,
    PlanningDefault
  }
}
</script>

<style scoped>
</style>
